import React, { Component } from 'react';
import { connect } from 'react-redux';

import PageHeader from '../../../shared/page-header/components/page-header';
import Video from './video';
import RenderIf from '../../../shared/render-if/components/render-if';
import BannerCodeModal from '../../banners/components/banner-code-modal';
import CreateCampaignModal from '../../campaigns/components/create-campaign-modal';
import ChooseCampaignModal from '../../campaigns/components/choose-campaign-modal';
import MobileCampaignModal from '../../campaigns/components/mobile-campaign-modal';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import constants from '../../../../common/constants';
import { videos_langugages, videos } from '../constants/videos-constants';

import '../styles/videos.css';

class Videos extends Component {
  state = {
    selectedLanguage: constants.languages.en,
  };

  renderVideos(videos) {
    if (videos && videos.length > 0) {
      return videos.map((video, index) => {
        return <Video {...video} key={index} />;
      });
    } else return null;
  }

  onLanguageChange = value => {
    this.setState({ selectedLanguage: value });
  };

  render() {
    const { campaigns, showBannerCodeModal } = this.props;
    const { selectedLanguage } = this.state;

    return (
      <div className="videos-container">
        <RenderIf if={campaigns && showBannerCodeModal}>
          <BannerCodeModal />
        </RenderIf>
        <ChooseCampaignModal />
        <CreateCampaignModal />
        <MobileCampaignModal />
        <PageHeader title={'VIDEOS.TITLE'} />
        <div className="col-sm-12">
          <ButtonsSelector items={videos_langugages} selectedValue={selectedLanguage} onClick={item => this.onLanguageChange(item)} />
        </div>
        <div className="row">{this.renderVideos(videos[selectedLanguage.value])}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns,
  showBannerCodeModal: state.bannersReducer.showBannerCodeModal,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Videos);



// WEBPACK FOOTER //
// ./src/app/main/videos/components/videos.js